module.exports = __webpack_public_path__ + "img/avatar-drinking-soju.90e5164e.png";